<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Martin Vicencio
    Author URL: Martin Vicencio
========================================================================================== -->

<template>
 <div id="invoice-page">  


     <vs-popup class="holamundo"  title="Lorem ipsum dolor sit amet" :active.sync="popupActive">
                <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </vs-popup>


  <vx-card>
    
 <!-- style="max-width: 1240px;" style="max-width: 1400px;"   -->
   <div class="card mb-3" >
    
      
    <div class="row g-0">
       <center style="padding:10px;" >  <h1>Mis Datos</h1> </center>
        
     <div class="col-md-4" style="padding:15px;" title="Nota: Favor de NO subir fotografías inadecuadas" >
       <a href="#"  @click="abrir_upload()">       
          <!-- <center style="padding:60px;" >     <br>     <br>          <br>  rounded-start 
          1.- border-radius: 18px; padding-left:10px;
          2.-  border-radius: 50%; padding-left:10px;
          3.-   border: 1px solid #ddd;  border-radius: 4px;  padding: 5px;  width: 150px;
          4.-   border: 1px solid #ddd;  border-radius: 4px;  padding: 5px;
          width="300" height="300"  width="300" height="400"     -->
      <img  style="border: 1px solid #ddd;  border-radius: 4px; padding: 5px;" v-show="foto_alumno!=null" :src="foto_alumno" alt="foto_alumno" class="img-fluid ">

     <img style="border: 1px solid #ddd;  border-radius: 4px; padding: 5px;"  v-show="foto_alumno==null" :src="require('@/assets/images/profile/user-uploads/'+user04+'.jpg')" alt="user_foto" class="img-fluid">
      
      </a>

     </div>

    <div class="col-md-8">
       <div class="card-body">


<!-- carbody inici -->
            
    <vx-card>
     
      <table>
          <tr>
            <th>
           <b>Programa Educativo</b> 
            </th>
            <td > 
        <div class="alert alert-warning" role="alert">
                               {{carrera_select}}
                               </div>
                              
                  </td>
                 </tr>
              
              <tr>
                <th>
                 <b>Matrícula </b> </th>
                <td>
                                       
                        <div class="alert alert-warning" role="alert">
                         {{matricula}}
                         </div>
                    
                </td>
              </tr>

                       <tr>
                <th>
                 <b>Cuatrimestre Formal</b> </th>
                <td>
                                       
                        <div class="alert alert-info" role="alert">
                         <!-- {{matricula}}                     
                          -->
                            {{calcular_cuatrimestre(matricula)}}
                         </div>
                    
                </td>
              </tr>

              <tr>
                <th> <b> Nombre </b></th>
                 <td>
                                    
                        <div class="alert alert-info" role="alert">
                       <!-- {{alumno_detalle2.ncompleto.toUpperCase()}} -->

                      {{ (alumno_detalle2.ncompleto || '').toUpperCase()}}
                                             </div>
                        
                  </td>
               </tr>

                <tr>
                <th> <b> CURP </b> </th>
                 <td>
                                  
                        <div class="alert alert-warning" role="alert">
                           {{alumno_detalle2['curp']}}
                           <!-- data[indextr].curp.substr(10,1)=='M' -->
                           <!-- {{alumno_detalle2['curp'].substr(4,6)}} -->
                           </div>
                        
                  </td>
               </tr>

             <tr>
                <th> <b> Fecha de Nacimiento </b> </th>
                 <td>
                                  
                        <div class="alert alert-warning" role="alert">
                           <!-- data[indextr].curp.substr(10,1)=='M' -->
                           {{calcular_fecha_nacimiento(alumno_detalle2['curp'])}}
                           <!-- {{alumno_detalle2['curp'].substr(8,2)+'-'+alumno_detalle2['curp'].substr(6,2)+'-'+alumno_detalle2['curp'].substr(4,2)}} -->
                           </div>
                        
                  </td>
               </tr>




                <tr>
                <th> <b> Estatus Académico </b> </th>
                <td>
                      

                     <div  v-if="alumno_detalle2['status_activo']==1"> 
                          <div class="alert alert-success" role="alert">
                              Alumno Activo
                            </div>
                       </div>
                       <div v-else>
                           <div class="alert alert-danger" role="alert">
                               Inactivo
                            </div>
                        </div>

                  </td>
               </tr>

                <tr>
                <th> <b>Seguro de Estudiante de Gastos Médicos contra Accidentes</b> </th>
                <td>
                      

                     <div  v-if="(alumno_detalle2['vigencia']>year_act)"> 
                          <div class="alert alert-primary" role="alert">
                           Seguro Activo  <br> Vigencia hasta: <b>"{{alumno_detalle2['vigencia']}}" </b> <br>
                           Periodo del: <b>"{{ alumno_detalle2['seguro_creado']}} al {{alumno_detalle2['vigencia']}}" </b>

                              <!-- {{year_act}}  -->
                            </div>
                       </div>
                       <div v-else>
                           <div class="alert alert-danger" role="alert">
                            Seguro Inactivo 
                            <!-- <br> Fecha de vigencia: {{alumno_detalle2['vigencia']}}       -->
                                <!-- {{year_act}}  -->
                            </div>
                        </div>

                  </td>
               </tr>
               <tr>
                <th>Materias Aprobadas</th>
                <td>   <div class="mt-5"> <center><b>({{cantidad_mat_apro}}/64 Total) </b></center></div></td>
               </tr>
               <tr>
                 <!-- <th>Trayectoria Académica Acreditada</th> -->
                                  <th>% Materias Aprobadas</th>
                    <td>
                      <!-- <div class="progress">  
                        <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
                        </div> -->
             <!--  <div class="progress">  
                        <div class="progress-bar" role="progressbar" style="width: 50%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                         {{progreso_materias}}%
                        </div> </div> -->
        <div class="mt-5">
            <!-- <center><b> {{ Math.round(progreso_materias)}}% </b></center>            -->
            
            <center><b> {{ text_progreso_materias }}% </b></center>           
<!--            
             <vs-progress v-show="progreso_materias<41" :height="14" :percent="progreso_materias" color="warning" ></vs-progress>
           <vs-progress  v-show="progreso_materias >= 40 && progreso_materias <= 70" :height="14" :percent="progreso_materias" color="orange"></vs-progress>
            <vs-progress  v-show="progreso_materias>69" :height="14" :percent="progreso_materias" color="success"></vs-progress> -->

         <vs-progress v-show="progreso_materias<70" :height="14" :percent="progreso_materias" color="warning" ></vs-progress>
           <!-- <vs-progress  v-show="progreso_materias >= 40 && progreso_materias <= 70" :height="14" :percent="progreso_materias" color="orange"></vs-progress> -->
            <vs-progress  v-show="progreso_materias>69" :height="14" :percent="progreso_materias" color="success"></vs-progress>

           
           <!-- <vs-progress :height="14" :percent="progreso_materias" color="success"></vs-progress> -->


        </div>

                       
                    </td>
               </tr>


    <!-- <vx-card title="Height" code-toggler> -->        
        <!-- <p>You can change the height of the loading bar with the property height</p>
        <vs-alert color="primary" icon="new_releases" active="true" class="mt-5">
                <p>By default the property <code>height</code> is <strong>5</strong>(5px)</p>
            </vs-alert>  -->
    <!-- </vx-card> -->


        </table>

      <vs-popup style=""  class="holamundo"  title="Cambiar Imagen:" :active.sync="popupActive_img">
           <div class="row">
               <input type="file" accept="image/jpeg" id="file_img_perfil" ref="file_img_perfil" v-on:change="onChangeFoto()" @click="previsualizar_img_clic()" />
                <br>
                <img v-show="file_img_perfil!=''" id="imagenPrevisualizacion"  width="40%" height="40%" >        
                <br>
                <vs-button style="margin:2px" :disabled="file_img_perfil==''"  @click="post_url()" > Actualizar</vs-button>
            </div>
         </vs-popup>
  
  
        <div class="vx-col w-full md:w-1/2 mt-base">
               <a href="https://upbicentenario.edu.mx/" target="_blank"><b>Página Web Oficial</b></a><br>
               <a href="https://upbicentenario.edu.mx/tu-universidad-en-linea/" target="_blank"><b>Trámites escolares y servicios de la Universidad</b></a>
         </div>
       </vx-card>





<!-- carbody fin -->
         </div>
        </div>
       </div>
      </div>

   </vx-card>
  </div>
</template>

<script>

export default{
    data() {
        return {
          progreso_materias:0,
          text_progreso_materias:0,
          cantidad_mat_apro:0,
            //  year_act: new Date(),
                // year_act:   new Date().toLocaleDateString(),
                    // year_act: new Date().getDate() + '-' + (new Date().getMonth()+1) + '-' + new Date().getFullYear(),
           year_act:new Date().getFullYear()+'-' + ('0' + (new Date().getMonth()+1)).slice(-2) +'-'+ ('0' + new Date().getDate()).slice(-2),
            id: localStorage.getItem('id'),
            matricula: localStorage.getItem('matricula'),
            alumno_detalle2: {},
             carrera_id:false,
            carrera_select:false,
            user04:'user1',
             popupActive_img:false,
              popupActive: false,
            foto_alumno:'',
             file_img_perfil: ''

        }
    },
    created() {
        this.getAlumno();

    },
    methods: {


    calcular_fecha_nacimiento(parametro_curp_alu){
      
      // let curp_text=parametro_curp_alu;
       var curp_fecha_nacimiento,tx1,tx2,tx3;
                  tx1=parametro_curp_alu.substr(8,2);
                  tx2=parametro_curp_alu.substr(6,2);
                  tx3=parametro_curp_alu.substr(4,2);
                  curp_fecha_nacimiento=tx1+'-'+tx2+'-'+tx3;


      return curp_fecha_nacimiento;

    },


     calcular_cuatrimestre(matricula){
                         
              var agno_matricula, periodo_matricula, agno_actual, periodo_actual;
                  agno_matricula='20'+matricula.substr(0,2);
                  periodo_matricula=matricula.substr(2,2);
                  agno_actual = new Date().getFullYear();

              // CEIL(MONTH(CURDATE())/4)
              var i=('0' + (new Date().getMonth()+1)).slice(-2);
                  periodo_actual = Math.ceil(i/4);
            //  document.getElementById("demo").innerHTML = f;
              var suma_periodos_cuatrimestres_total_temp = 0;
              
            if(agno_matricula!=agno_actual){              
              for( var j=agno_matricula; j<agno_actual; j++){
                   var  periodos_por_agno;
                        periodos_por_agno=3; 
                     suma_periodos_cuatrimestres_total_temp+=periodos_por_agno;              
                   
                  }

                   if(periodo_matricula == 1){
                        suma_periodos_cuatrimestres_total_temp;   

                     }else if(periodo_matricula == 2){

                          // code
                           var varlor_uno=(suma_periodos_cuatrimestres_total_temp-1);
                              suma_periodos_cuatrimestres_total_temp=varlor_uno;  
                     }else{
                      // code
                      var varlor_dos=(suma_periodos_cuatrimestres_total_temp-2);
                     suma_periodos_cuatrimestres_total_temp=varlor_dos;   
                     }

             // arreglar las matriculas 9,10,11,12,13
               return suma_periodos_cuatrimestres_total_temp+periodo_actual;

            }else{
              var cuatri_actual;

                 if(periodo_matricula == 1){
                        cuatri_actual=periodo_actual;   

                     }else if(periodo_matricula == 2){
                           cuatri_actual=periodo_actual-1;   
                           
                     }else{
                        cuatri_actual=periodo_actual-2;   
                     }

               return cuatri_actual;

            }

  },

  abrir_upload(){
        this.popupActive_img = true;  
        },


        
onChangeFoto(){
  
      var fileName = document.getElementById("file_img_perfil").value;
        var idxDot = fileName.lastIndexOf(".") + 1;
        var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
        if (extFile=="jpg" || extFile=="jpeg" || extFile=="png"){
            this.file_img_perfil = this.$refs.file_img_perfil.files[0];
                       
        }else{
            alert("¡Solo imagenes jpg/jpeg y png estan permitidas!");
            document.getElementById("file_img_perfil").value=''
        }

      
    },


previsualizar_img_clic(){

              const $file_img_perfil = document.querySelector("#file_img_perfil"),
                $imagenPrevisualizacion = document.querySelector("#imagenPrevisualizacion");

                 // Escuchar cuando cambie
                 file_img_perfil.addEventListener("change", () => {
                   // Los archivos seleccionados, pueden ser muchos o uno
                   const archivos = $file_img_perfil.files;
                   // Si no hay archivos salimos de la función y quitamos la imagen
                   if (!archivos || !archivos.length) {
                     $imagenPrevisualizacion.src = "";
                     return;
                   }
                   // Ahora tomamos el primer archivo, el cual vamos a previsualizar
                   const primerArchivo = archivos[0];
                   // Lo convertimos a un objeto de tipo objectURL
                   const objectURL = URL.createObjectURL(primerArchivo);
                   // Y a la fuente de la imagen le ponemos el objectURL
                     $imagenPrevisualizacion.src = objectURL;
                    
                 });

},

         post_url(){

            let formData = new FormData();
            formData.append('file_img_perfil', this.file_img_perfil);
            // https://cdn.upbicentenario.edu.mx/api/upload_img_perfil_admin/id_usuario

      this.$http.post('upload_img_perfil_alumnos/'+this.id+'/'+this.matricula,
                 formData, {   headers: {   'Content-Type': 'multipart/form-data'   }   }       
                ).then(response => {
         if(response.data.mensaje == '1'){
            this.successUpload();
            this.file_img_perfil='';
            this.popupActive_img = false;  
            location.reload();         
          }else{
             response.data.mensaje;
           }

         });

        },

          successUpload(){
            this.$vs.notify({  time: 2600,color: 'success', title: 'Cargada de Imagen', text: 'Imagen cargada correctamente' })
        },

        getAlumno() {
            this.$http.get("alumno_id/" + this.id).then(
                response => {
                    this.alumno_detalle2 = response.data.alumno;
                  this.carrera_id=this.alumno_detalle2['idCarrera'];
                   var result_progreso_materias=this.alumno_detalle2['materias_acreditadas'];
                                var cantidad_progreso_materias=parseInt(result_progreso_materias, 0);
                    // this.cantidad_mat_apro=cantidad_progreso_materias;
                  if(cantidad_progreso_materias>64){
                       this.cantidad_mat_apro=64;
                       }else{
                           this.cantidad_mat_apro=cantidad_progreso_materias;
                      }

                    // this.progreso_materias=((cantidad_progreso_materias/64)*100);
                     var progreso_materias1=((cantidad_progreso_materias*100)/64);
                      this.progreso_materias=Math.round(progreso_materias1);
                      if(this.progreso_materias>100){
                    this.text_progreso_materias=100;
                    this.progreso_materias;
                      }else{
                    this.text_progreso_materias=this.progreso_materias;

                      }
                     

                    //  Math.round(2.5);
                  // console.log(this.progreso_materias);
                  // console.log(cantidad_progreso_materias);
                  // console.log(this.progreso_materias);

                  this.getCarrera(this.carrera_id);
                  if(this.alumno_detalle2['img']==null){
                        this.foto_alumno=null;
                  }else{

                 this.foto_alumno='https://cdn.upbicentenario.edu.mx/img_alumnos/'+this.alumno_detalle2['img'];

                  }     

                },
                error => {
                    this.StepError(error);
                }
            );
        },

        //mas metodos
               getCarrera(carrera_id){
              this.$http.get("carrera_id/" +carrera_id).then(
                response => {
                    this.carrera_select= response.data.carrera[0].nombre;
                },
                error => {
                    this.StepError(error);
                }
            );

        }

    }
}
</script>
